import { LRUCache } from 'lru-cache';

const promiseCache = new Map<string, Promise<unknown>>();
const resultCache = new LRUCache<string, { data: unknown; expiresAt: number }>({
  max: 100,
  ttl: 0, // Default TTL not used directly, we'll manage it manually
});

export async function cachedQuery<T>(
  key: string,
  fn: () => Promise<T>,
  ttl = 60_000 // default 60 seconds
): Promise<T> {
  const now = Date.now();
  const cached = resultCache.get(key);
  if (cached && cached.expiresAt > now) {
    return cached.data as T;
  }

  if (promiseCache.has(key)) {
    return promiseCache.get(key) as Promise<T>;
  }

  const promise = fn().then((data) => {
    resultCache.set(key, { data, expiresAt: Date.now() + ttl });
    promiseCache.delete(key);
    return data;
  });

  promiseCache.set(key, promise);
  return promise;
}